// 轮播图信息模块
import request from "@/utils/request"

//获取轮播图
export const getBanner = params =>{
  return request({
    method:'GET',
    url:'/banner/es',
    params
  })
}